<template lang="pug">
  tr
    td(:colspan="columns - 3")
      span
        b {{ $t(`table.${type}.${removed ? 'rowActivateText' : 'rowDeactivateText'}`, [confirmationKey]) }}
    td.text-sm-right.row_confirmation_buttons(:colspan="3")
      v-btn.mr-4(
        small, color="info",
        @click="$emit('cancel')",
      ) {{ $t(`table.${type}.rowCancelText`) }}
      v-btn(
        small, :color="removed ? 'success': 'error'",
        @click="$emit('confirm')",
      ) {{ $t(`table.${type}.rowConfirmText`) }}
</template>

<script>
export default {
  props: {
    columns: {
      type: Number,
      required: true,
    },

    removed: {
      type: Boolean,
      required: true,
    },

    confirmationKey: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },
  },
};
</script>
